/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */

define(['backbone'], function(backbone) {
    return backbone.Model.extend({
        defaults: {
            /**
             * @type {string}
             */
            name: '',

            /**
             * @type {string}
             */
            value: '',

            /**
             * @type {string}
             */
            title: '',

            /**
             * @type {boolean}
             */
            active: false,

            /**
             * @type {boolean}
             */
            disabled: false
        }
    });
});
